import { Box, Typography } from '@ori-ui/mui';
import type { VFC } from 'react';

import type { VipAccessData, VipAccessLabels } from '~/models';

interface VipOrderConsultantProps {
  vipAccessData: VipAccessData;
  vipAccessLabels: VipAccessLabels;
}

const consultantDetail = (label: string, value: string) => `${label} ${value}`;

export const VipOrderConsultant: VFC<VipOrderConsultantProps> = ({
  vipAccessData: {
    AvailableCredit,
    Debt,
    GroupBp,
    PersonalBp,
    RemainingDiscount,
    RemainingPrepayment,
  },
  vipAccessLabels: {
    AvailableCredit: availableCreditLabel,
    Debt: debtLabel,
    GroupBp: groupBpLabel,
    PersonalBp: personalBpLabel,
    RemainingDiscount: remainingDiscountLabel,
    RemainingPrepayment: remainingPrepaymentLabel,
  },
}) => (
  <Box sx={{ mx: 0, my: 3 }}>
    {PersonalBp ? (
      <Typography variant="body1">{consultantDetail(personalBpLabel, PersonalBp)}</Typography>
    ) : null}
    {GroupBp ? (
      <Typography variant="body1">{consultantDetail(groupBpLabel, GroupBp)}</Typography>
    ) : null}
    {AvailableCredit ? (
      <Typography variant="body1">
        {consultantDetail(availableCreditLabel, AvailableCredit)}
      </Typography>
    ) : null}
    {Debt ? <Typography variant="body1">{consultantDetail(debtLabel, Debt)}</Typography> : null}
    {RemainingDiscount ? (
      <Typography variant="body1">
        {consultantDetail(remainingDiscountLabel, RemainingDiscount)}
      </Typography>
    ) : null}
    {RemainingPrepayment ? (
      <Typography variant="body1">
        {consultantDetail(remainingPrepaymentLabel, RemainingPrepayment)}
      </Typography>
    ) : null}
  </Box>
);
